import React from "react";
import {ICardNetworkViewModel, ICardNetworkIconOptions} from "./card-network.view-model.interface";
import {CardNetworksEnum} from "../../payment-method-codes.enum";

export abstract class CardNetworkModel implements ICardNetworkViewModel {
    constructor(public readonly code: CardNetworksEnum) {
    }

    abstract get name(): string;
    abstract renderIcon(options?: ICardNetworkIconOptions): React.ReactElement | null;
}